import { SET_SELECTED_ORIGIN_PORT } from '../actions/actionTypes';

const initialState: string = '';

export const originPortReducer = (state: string = initialState, action: any) => {
  switch (action.type) {
    case SET_SELECTED_ORIGIN_PORT:
      return action.data;
    default:
     return state;
  };
};
